<template>
  <div>
    <Head title="Periode Beasiswa" />
    <h1 class="mb-8 text-2xl font-bold">Periode Beasiswa</h1>
    <div class="flex items-center justify-end mb-6">
      <Link v-if="can('write periode beasiswa')" class="btn-indigo" href="/scholarships/create">
        <span><font-awesome-icon icon="fas fa-plus" class="mr-2" />Tambah</span>
      </Link>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Nama Periode</th>
            <th class="px-6 pt-6 pb-4">Keterangan</th>
            <th class="px-6 pt-6 pb-4">Kuota Per Kampus</th>
            <th class="px-6 pt-6 pb-4">Status</th>
            <th v-if="can('write periode beasiswa')" class="px-6 pt-6 pb-4 border-b">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="scholarship in scholarships.data" :key="scholarship.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-4 border-t">
              {{ scholarship.nama }}
            </td>
            <td class="p-4 border-t">
              {{ scholarship.keterangan }}
            </td>
            <td class="p-4 border-t">
              <ul>
                <li> {{ scholarship.kuota_mou }}</li>
              </ul>
            </td>
            <td class="p-4 text-center border-t">
              {{ scholarship.status }}
            </td>
            <td v-if="can('write periode beasiswa')" class="w-px p-4 border-t">
              <Link class="rounded-l btn-indigo-sm" :href="`/scholarships/${scholarship.id}/edit`">
                <font-awesome-icon icon="fas fa-pencil" />
              </Link>
              <Link class="rounded-r btn-red-sm" @click.prevent="destroy(scholarship.id)">
                <font-awesome-icon icon="fas fa-trash" />
              </Link>
            </td>
          </tr>
          <tr v-if="scholarships.data.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write periode beasiswa')? 5 : 4">Tidak ada data periode beasiswa.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="scholarships.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    scholarships: Object,
  },

  methods: {
    destroy(id) {
      this.$swal.fire({
        title: 'Anda yakin hapus data ini?',
        text: 'Anda tidak akan dapat mengembalikan data yang sudah dihapus!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/scholarships/${id}`)
        }
      })
    },
  },
}
</script>
